import React, { useContext, ReactNode } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import DSPCharts from './DSP';
import OfficialCharts from './Official';

import { EntityContext } from 'context/entityContext';

import { chartsSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import RadioCharts from './Radio';

const Charts: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix } = props;
  const { entities } = match.params;
  const ctx = useContext(EntityContext);
  const { compareMode, topic } = ctx;

  return (
    <>
      <SubNavigation topic="charts" variants={chartsSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />
      <Switch>
        <Route
          exact
          path={`${pathPrefix}/artist/${entities}/charts/dsp`}
          render={(routerProps): ReactNode => (
            <DSPCharts {...ctx} {...routerProps} />
          )}
        />
        <Route
          exact
          path={`${pathPrefix}/artist/${entities}/charts/official`}
          render={(routerProps): ReactNode => (
            <OfficialCharts {...ctx} {...routerProps} />
          )}
        />

        <Route
          exact
          path={`${pathPrefix}/artist/${entities}/charts/radioCharts`}
          render={(routerProps): ReactNode => (
            <RadioCharts {...ctx} {...routerProps} />
          )}
        />
        <Redirect
          exact
          from={`${pathPrefix}/artist/${entities}/charts/positionTracker`}
          to={`${pathPrefix}/artist/${entities}/charts/dsp`}
        />
      </Switch>
    </>
  );
};

export default Charts;
